import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';
import SingleBlog from '../../components/Blog';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import blogImg1 from '../../assets/img/blog/blog-1-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-1-2.jpg';
import blogImg3 from '../../assets/img/blog/blog-1-3.jpg';

const Blog = () => {
  return (
    <div
      id="it-blog"
      className="it-blog-area it-blog-style-2 fix p-relative pt-75 pb-90"
    >
      <div className="it-blog-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-blog-title-box mb-65">
          <div className="row align-items-end">
            <div className="col-xl-7 col-lg-6 col-md-6">
              <SectionTitle
                itemClass="it-blog-title-box"
                subTitleClass="it-section-subtitle green"
                subTitle="Blog"
                titleClass="it-section-title"
                title="Our recent Post"
              />
            </div>
            <div className="col-xl-5 col-lg-6 col-md-6">
              <div className="it-blog-button text-md-start">
                <Link to="/blog" className="it-btn-theme grey-bg">
                  <Button btnText="All Blog" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleBlog
              blogImage={blogImg1}
              publishedDate="10"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              titleClass="hover-anim green"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleBlog
              blogImage={blogImg3}
              publishedDate="20"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              titleClass="hover-anim green"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleBlog
              blogImage={blogImg2}
              publishedDate="25"
              publishedMonth="March 24"
              authorName="Camsth Smith"
              titleClass="hover-anim green"
              title="Healthcare Tips Navigating Business Patient Care"
              btnText="Read More"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
